// extracted by mini-css-extract-plugin
export default {"Second_Section":"Livery_Second_Section__+AWcF","SecondSection_p":"Livery_SecondSection_p__w57Qy","Second_Sectiontext":"Livery_Second_Sectiontext__VLh36"};